import { render, staticRenderFns } from "./global_search_autocomplete_items.vue?vue&type=template&id=dc3f309a"
import script from "./global_search_autocomplete_items.vue?vue&type=script&lang=js"
export * from "./global_search_autocomplete_items.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports